module.exports = flarum.core.compat['utils/Stream'];